/**
 * For persisting user preferences
 *
 * requires jquery.cookie.js
 *
 *
 * Usage:
 * $.userPref('set', 'key', value);				stores a preference
 * $.userPref('setTemp', 'key', value);	stores a preference on the client only (for scroll positions etc)
 * $.userPref('getTemp', 'key')				retrieves a preference stored on the client
 *
 *
 *
 * TODO: move file, this is a backend helper, not a seekom widget --- BUT still required by v3.1
 *
 */
(function($){

	var timeoutHandle = null;
	var buffer = new Object();

	var options = {
		delay : 0,
		url: '/user-prefs/set',
		cookiePrefix : 'user-pref-temp--',
		onSuccess: function(){}
	};

	var methods = {
		get: function(key){
			if(USER_PREFS[key]) return USER_PREFS[key];
			return null;
		},
	    set: function(key, value){
	    	var data;
			if(typeof key === 'object' && value == null){
				// param "key" is an object, a set of key-value pairs
				data = key;
				for(var k in key){
					var v = key[k];
					USER_PREFS[k] = v;
				}
			}else{
				data = {};
				data[key] = value;
				USER_PREFS[key] = value;
			}
			$.ajax({
				url: options.url,
				data: data,
				type: 'POST',
				success: function(){
					options.onSuccess();
				}
			});
		},
	    getTemp: function(key){
			if($.cookie(options.cookiePrefix + key)) return $.cookie(options.cookiePrefix + key);
			return null;
		},
	    setTemp: function(key, value, opts){
				if(typeof opts !== 'object') {
					opts = {};
				}

				if(typeof opts.path !== 'string') {
					opts.path = '/';
				}

				$.cookie(options.cookiePrefix + key, value, opts);
		},
		options: function(overrides){
			$.extend(options, overrides);
			return this;
		}
	};

	$.userPref = function(method) {
		// Method calling logic
		if ( methods[method] ) {
			return methods[ method ].apply( this, Array.prototype.slice.call( arguments, 1 ));
		} else if ( typeof method === 'object' || ! method ) {
			return methods.init.apply( this, arguments );
		} else {
			$.error( 'Method ' +  method + ' does not exist on jQuery.tooltip' );
		}
	};

})(jQuery);
